import type { ExperimentInstanceResponse } from '../types/api';
import type { ExperimentInstance } from '../types/app';

export function experimentInstanceMapper(data: ExperimentInstanceResponse['data'][0]): ExperimentInstance {
  return {
    instanceName: data.instance_name,
    name: data.name,
    description: data.description,
    definition: data.definition,
  };
}
